import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0 0h1024v1024H0z"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 4542.11,
		cy: 534.805,
		r: 406.805,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 68.97,
		transform: "translate(-4229.72 -47.644)scale(1.04395)"
	})]
});
export default SvgIconCircle;
